import { createFileRoute } from '@tanstack/react-router';
import { ConnectorsPage, type ConnectorsSearch } from '@/features/connectors/ConnectorsPage';

const str = (v: unknown) => (typeof v === 'string' && v ? v : undefined);

/** "Konnektorlar" registry. URL state: `?panel=new|<id>` create / edit panel, `&type=<connector type>` preselected type. */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/connectors/')({
  validateSearch: (search: Record<string, unknown>): ConnectorsSearch => ({ panel: str(search.panel), type: str(search.type) }),
  component: ConnectorsRoute,
});

function ConnectorsRoute() {
  const { tenant, me } = Route.useRouteContext();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <ConnectorsPage tenant={tenant} me={me} search={search} onSearch={(next) => void navigate({ search: next })} />;
}
